import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';

function ShibaPage() {
  const [shibaList, setShibaList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchShibaData = async () => {
      try {
        // const res = await axios.get("http://127.0.0.1:8000/api/shiba");
        const res = await axios.get('/api/shiba');
        setShibaList(res.data);
      } catch (error) {
        console.error('データ取得失敗:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchShibaData();
  }, []);

  if (loading) {
    return <div>読み込み中...</div>;
  }

  return (
    <Box
      p={4}
      sx={{
        width: { xs: '100%', sm: 'auto' },
        padding: '5px', // スマホのとき横幅100%、PCのときは自動
      }}
    >
      <Typography
        variant="h4"
        gutterBottom
        sx={{
          fontSize: { xs: '1.5rem', sm: '2.125rem' }, // スマホは少し小さく
        }}
      >
        芝 一覧
      </Typography>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  fontSize: { xs: '0.7rem', sm: '0.8rem' }, // スマホは少し小さく
                  padding: '3px',
                  textAlign: 'center',
                }}
              >
                レース情報
              </TableCell>
              <TableCell
                sx={{
                  fontSize: { xs: '0.7rem', sm: '0.8rem' }, // スマホは少し小さく
                  padding: '3px',
                  textAlign: 'center',
                }}
              >
                馬番
              </TableCell>
              <TableCell
                sx={{
                  fontSize: { xs: '0.7rem', sm: '0.8rem' }, // スマホは少し小さく
                  padding: '3px',
                  textAlign: 'center',
                }}
              >
                オッズ
              </TableCell>
              <TableCell
                sx={{
                  fontSize: { xs: '0.7rem', sm: '0.8rem' }, // スマホは少し小さく
                  padding: '3px',
                  textAlign: 'center',
                }}
              >
                単勝確率
              </TableCell>
              <TableCell
                sx={{
                  fontSize: { xs: '0.7rem', sm: '0.8rem' }, // スマホは少し小さく
                  padding: '3px',
                  textAlign: 'center',
                }}
              >
                新単勝確率
              </TableCell>
              <TableCell
                sx={{
                  fontSize: { xs: '0.7rem', sm: '0.8rem' }, // スマホは少し小さく
                  padding: '3px',
                  textAlign: 'center',
                }}
              >
                複勝確率
              </TableCell>
              <TableCell
                sx={{
                  fontSize: { xs: '0.7rem', sm: '0.8rem' }, // スマホは少し小さく
                  padding: '3px',
                  textAlign: 'center',
                }}
              >
                期待値
              </TableCell>
              <TableCell
                sx={{
                  fontSize: { xs: '0.7rem', sm: '0.8rem' }, // スマホは少し小さく
                  padding: '3px',
                  textAlign: 'center',
                }}
              >
                対象
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {shibaList.map((shiba) => (
              <TableRow key={shiba.id}>
                <TableCell>{shiba.race_info}</TableCell>
                <TableCell>{shiba.umaban}</TableCell>
                <TableCell>{shiba.tansho_odds}</TableCell>
                <TableCell>{shiba.probability}%</TableCell>
                <TableCell>{shiba.newtanmodelprobability}%</TableCell>
                <TableCell>{shiba.fukushoprobabilitty}%</TableCell>
                <TableCell>{shiba.hit_predict_persent}</TableCell>
                <TableCell>{shiba.prediction}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default ShibaPage;
